import React, { useEffect, useState } from 'react';
import Navbar from '../Navbar/Navbar';
import { useDispatch, useSelector } from 'react-redux';
import { getEmailData } from '../../Redux/Config/Action';
import NewDataTable from '../DataTable/NewDataTable';
import Select from "react-select";
import DatePicker from 'react-datepicker';
import { startOfMonth } from "date-fns";
import { format } from 'date-fns';
import { FaEdit } from 'react-icons/fa';
import { FaEye } from "react-icons/fa";


const EmailData = () => {


    const dispatch = useDispatch();
    const token = localStorage.getItem("token");
    const { emaildata } = useSelector((store) => store.config);
    const [fromDate, setFromDate] = useState(startOfMonth(new Date()));
    const [toDate, setToDate] = useState(new Date());
    const [rowData, setRowData] = useState();
    const [show, setShow] = useState(false);

    useEffect(() => {
        dispatch(getEmailData(token, format(fromDate, "yyyy-MM-dd"), format(toDate, "yyyy-MM-dd")));
    }, [dispatch, token, fromDate, toDate]);



    const Tooltip = ({ text, children }) => {
        return (
            <div className="tooltip-container">
                {children}
                <div className="tooltip">{text}</div>
            </div>
        );
    };

    const handleClose = () => {
        setShow(false);
        setRowData(null);
    };

    const handleView = (data) => {
        setRowData(data);
        setShow(true);

    }

    const columns = [
        {
            name: "SN",
            cell: (_, index) => index + 1,
            sortable: false,
            width: "80px",
            align: "center",
        },
        {
            name: "Mail To",
            selector: (row) => row?.mailTo || "-",
            sortable: true,
            align: "left",
        },
        {
            name: "Subject",
            selector: (row) => row?.subject || "-",
            sortable: true,
            align: "left",
        },
        {
            name: "Status",
            selector: (row) => row?.status || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Error Message",
            selector: (row) => row?.errorMessage || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Action",
            selector: (row) => row,
            sortable: false,
            align: "center",
            cell: (row) => (
                <Tooltip text="View">
                    <FaEye
                        className="text-info" size={20}
                        onClick={() => handleView(row)}
                        style={{ cursor: "pointer" }}
                    />
                </Tooltip>

            ),

        },
    ];

    const formatLabel = (key) =>
        key
            .replace(/([A-Z])/g, " $1")
            .replace(/^./, (str) => str.toUpperCase());

    return (
        <div>
            <Navbar></Navbar>
            <div className="main-content">
                <div className="container-fluid mt-4">
                    <div className="row mb-3 justify-content-end align-items-center flex-wrap">


                        {/* From & To Dates in one row */}
                        <div className="col-auto d-flex align-items-center flex-nowrap mb-2 mb-sm-0">
                            <b>
                                <label className="me-1 mb-0 custom-label cstm-label">From Date:</label>
                            </b>
                            <DatePicker
                                selected={fromDate}
                                onChange={(newValue) => setFromDate(newValue)}
                                className="form-control me-3"
                                dateFormat="dd-MM-yyyy"
                                showYearDropdown
                                showMonthDropdown
                                dropdownMode="select"
                                onKeyDown={(event) => event.preventDefault()}
                            />

                            <b>
                                <label className="me-1 ms-2 mb-0 custom-label cstm-label">To Date:</label>
                            </b>
                            <DatePicker
                                selected={toDate}
                                onChange={(newValue) => setToDate(newValue)}
                                className="form-control"
                                dateFormat="dd-MM-yyyy"
                                showYearDropdown
                                showMonthDropdown
                                dropdownMode="select"
                                onKeyDown={(event) => event.preventDefault()}
                                minDate={fromDate}
                            />
                        </div>

                    </div>
                    <div>
                        <div>
                            <NewDataTable
                                columns={columns}
                                data={emaildata || []}
                                tableName="EMAIL HISTORY"
                                totalRecord={emaildata?.length ?? 0}
                            />

                        </div>
                    </div>
                </div>
            </div>
            <div
                className={`modal leave-modal ${show ? "d-block" : "d-none"}`}
                tabIndex="-1"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
            >
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h5 className="modal-title">Email Details</h5>
                            <button type="button" className="btn-close" onClick={handleClose} />
                        </div>

                        <div className="modal-body">
                            {!rowData ? (
                                <p className="text-muted">No data</p>
                            ) : (
                                <>
                                    {rowData.errorMessage && (
                                        <div className="alert alert-danger">
                                            {rowData.errorMessage}
                                        </div>
                                    )}

                                    {/* {rowData?.modelJson && (
                                        <div className="mt-3">
                                            <h6 className="fw-bold mb-2">Model JSON</h6>

                                            <pre
                                                className="bg-light border rounded p-3 small"
                                                style={{
                                                    maxHeight: "200px",
                                                    overflowY: "auto",
                                                    whiteSpace: "pre-wrap",
                                                    wordBreak: "break-word",
                                                    fontFamily: "monospace",
                                                }}
                                            >
                                                {JSON.stringify(
                                                    typeof rowData.modelJson === "string"
                                                        ? JSON.parse(rowData.modelJson)
                                                        : rowData.modelJson,
                                                    null,
                                                    2
                                                )}
                                            </pre>
                                        </div>
                                    )} */}


                                    <div className="row g-3">
                                        {Object.entries(rowData)
                                            .filter(
                                                ([key]) =>
                                                    key !== "modelJson" &&
                                                    key !== "emailReceiverId" &&
                                                    key !== "errorMessage"
                                            )
                                            .map(([key, value]) => (
                                                <div key={key} className="col-md-3 col-sm-6">
                                                    <div className="border rounded p-2 h-100">
                                                        <div className="fw-bold text-muted small">
                                                            {formatLabel(key)}
                                                        </div>
                                                        <div className="text-break">
                                                            {value !== null && value !== undefined
                                                                ? value.toString()
                                                                : "-"}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                    </div>
                                </>
                            )}
                        </div>


                    </div>
                </div>
            </div>

        </div>
    );
};

export default EmailData;